import { $translate } from '@/utils/i18n';
export const tableConfig = {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: $translate('lang.E3202101280001', { defaultText: '条码字符串' }),
                align: 'center',
                prop: 'barcodeNo',
                filter: true,
                require: true,
                fixed: 'left',
                sort: true,
                width: 200
            },
            {
                label: $translate('lang.E3202101280038', { defaultText: '单据编码' }),
                align: 'center',
                prop: 'sourceBillNo',
                filter: true,
                require: true,
                fixed: 'left',
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202101280032', { defaultText: '来源系统' }),
                align: 'center',
                prop: 'recSourceSys',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202101280025', { defaultText: '流向写入日期' }),
                align: 'center',
                prop: 'receiveDate',
                filter: true,
                require: true,
                sort: true,
                width: 142
            },
            {
                label: $translate('lang.E3202101270011', { defaultText: '单据日期' }),
                align: 'center',
                prop: 'billDate',
                filter: true,
                require: true,
                sort: true,
                width: 90
            },
            {
                label: $translate('lang.E3202101280037', { defaultText: '扫码日期' }),
                align: 'center',
                prop: 'opDate',
                filter: true,
                require: true,
                sort: true,
                width: 90
            },
            {
                label: $translate('lang.E3202101280036', { defaultText: '生产日期' }),
                align: 'center',
                prop: 'prodDate',
                filter: true,
                require: true,
                sort: true,
                width: 90
            },
            {
                label: $translate('lang.E3202101280035', { defaultText: '最终节点' }),
                align: 'center',
                prop: 'isEndDict',
                filter: true,
                require: true,
                sort: true,
                width: 90
            },
            {
                label: $translate('lang.E3202112160001', { defaultText: '出入库类型' }),
                align: 'center',
                prop: 'inoutType',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202101280034', { defaultText: '发货仓库编码' }),
                align: 'center',
                prop: 'shipOrgCode',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202101280007', { defaultText: '发货仓库名称' }),
                align: 'center',
                prop: 'shipOrgName',
                filter: true,
                require: true,
                sort: true,
                width: 240
            },
            {
                label: $translate('lang.E3202101280033', { defaultText: '发货仓库类型' }),
                align: 'center',
                prop: 'shipOrgTypeDict',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202101280031', { defaultText: '收货仓库编码' }),
                align: 'center',
                prop: 'recOrgCode',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202101280008', { defaultText: '收货仓库名称' }),
                align: 'center',
                prop: 'recOrgName',
                filter: true,
                require: true,
                sort: true,
                width: 240
            },
            {
                label: $translate('lang.E3202101280030', { defaultText: '收货仓库类型' }),
                align: 'center',
                prop: 'recOrgTypeDict',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202101280009', { defaultText: '直发客户编码' }),
                align: 'center',
                prop: 'customerCode',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202101280010', { defaultText: '直发客户名称' }),
                align: 'center',
                prop: 'customerName',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202101280003', { defaultText: '产品编码' }),
                align: 'center',
                prop: 'itemCode',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202101280013', { defaultText: '产品名称' }),
                align: 'center',
                prop: 'itemName',
                filter: true,
                require: true,
                sort: true,
                width: 300
            },
            {
                label: $translate('lang.E3202101280029', { defaultText: '订单生产编码' }),
                align: 'center',
                prop: 'productOrderNo',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202101280028', { defaultText: '产品单位' }),
                align: 'center',
                prop: 'uomCode',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202101280027', { defaultText: '扫码人名称' }),
                align: 'center',
                prop: 'opPerson',
                filter: true,
                require: true,
                sort: true,
                width: 160
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
